import { RequestData, ConfigData } from '../config/StoreLocatorTextResources';
import { MULTIPLELOCATIONSSERVICE } from '../services/multiple.locations.service';
import { SINGLELOCATIONSERVICE } from '../services/single.location.service';
//import WebComponentStoreLocatorSingleLocation from '../templates/cwc-store-locator-single-location';
import { SEARCHSERVICE } from '../services/search.service';
import { TEMPLATE } from '../templates/cwc-templates';
import { FILTER } from '../services/filter.service';
import { MARKER } from '../services/google.marker.service';

export class StoreLocatorComponent {
  /**
   * Propertys
   */
  requestData: object;
  requestDataHello: object;
  requestDataLocation: object;
  requestDistance: number = 10;
  receiveParameters: boolean;
  searchOfLocId: boolean;
  searchValue: string;
  backButton: Element;
  currentCity: string;
  geoCoords: object;
  storeLocatorHtmlElement = document.querySelector<HTMLElement>('cwc-store-locator');
  mapLocationHtmlElement: HTMLElement;
  mapContentHtmlElement: HTMLElement;
  sidebarHtmlElement: HTMLElement;
  searchHtmlElement: HTMLElement;
  mapHtmlElement: HTMLElement;

  /**
   * If parameter is included in URL, the received parameter is passed on to the search parameter
   * and determines whether a single location is requested or the entire city.
   */
  setSearchParams(receiveParameters: boolean, singleLocations: boolean, searchValue: string) {
    this.receiveParameters = receiveParameters;
    this.searchOfLocId = singleLocations;
    this.searchValue = searchValue;
  }

  fetchLocationData(searchValue: string, searchLocId: boolean, searchCoords?: object) {
    this.setRequestData(searchValue, searchLocId, searchCoords);
    this.initHTMLElements();

    if (searchLocId) {
      return SINGLELOCATIONSERVICE.xtciRequest();
    } else if (searchValue !== '' || searchCoords) {
      return MULTIPLELOCATIONSSERVICE.xtciRequest();
    } else {
      if (!ConfigData.data['forceDisplaySearchFild']) {
        this.initGeolokationCoords();
      } else {
        this.displaySearchElement();
      }
    }
  }

  setRequestData(searchValue: string, locId: boolean, coords: object) {
    if (this.requestData === undefined) {
      this.requestData = RequestData['request']['init'];
    }
    if (this.requestDataHello === undefined) {
      this.requestDataHello = RequestData['request']['hello'];
    }

    if (locId) {
      this.requestDataLocation = { loc_id: searchValue };
    } else if (!locId && searchValue !== '') {
      this.requestDataLocation = { city: searchValue };
    } else if (coords) {
      this.requestDataLocation = { latitude: coords['lat'] };
      this.requestDataLocation = Object.assign(this.requestDataLocation, { longitude: coords['lng'] });
      // Search radius in km
      this.requestDataLocation = Object.assign(this.requestDataLocation, { distance: this.requestDistance });
      // Increase the search radius yourself if you haven't found any entries yet.
      this.requestDataLocation = Object.assign(this.requestDataLocation, { force_hit: 1 });
    }
    if (RequestData['request']['location'].onsite_printer_only > 0 && this.requestDataLocation !== undefined) {
      this.requestDataLocation['onsite_printer_only'] = 1;
    }
  }

  getRequestData(requestType: string) {
    let data = this.getData();

    if (requestType === 'hello_request') {
      if (data['city']) {
        delete data['city'];
      }
      if (data['loc_id']) {
        delete data['loc_id'];
      }
      if (data['latitude']) {
        delete data['latitude'];
      }
      if (data['longitude']) {
        delete data['longitude'];
      }
      if (data['distance']) {
        delete data['distance'];
      }
      if (data['force_hit']) {
        delete data['force_hit'];
      }
      if (data['onsite_printer_only']) {
        delete data['onsite_printer_only'];
      }
      data = Object.assign(data, this.getDataHello());
    }
    if (requestType === 'locationlist_request') {
      if (data['server_protocol']) {
        delete data['server_protocol'];
      }
      data = Object.assign(data, this.getDataLocation());
    }
    return data;
  }

  getData() {
    return this.requestData;
  }
  getDataHello() {
    return this.requestDataHello;
  }
  getDataLocation() {
    return this.requestDataLocation;
  }

  displayNoticeOverlay(message) {
    const noticeOverlayWrapper = this.storeLocatorHtmlElement.shadowRoot.querySelector<HTMLElement>('cwc-map-notice');
    const notice = noticeOverlayWrapper.querySelector('notice-content');
    const noticeOverlay = notice ? notice : document.createElement('notice-content');

    noticeOverlay.textContent = message;
    noticeOverlayWrapper.className = 'notice';
    noticeOverlayWrapper.appendChild(noticeOverlay);
    this.handleDisplayNotice(noticeOverlayWrapper);
  }

  handleDisplayNotice(element) {
    let timeoutID;
    if (!document.querySelector('cwc-map-notice.show')) {
      element.classList.toggle('show');
    }
    if (typeof timeoutID === 'number') {
      clearTimeout(timeoutID);
    }
    timeoutID = setTimeout(() => {
      element.classList.toggle('show');
      timeoutID = undefined;
    }, 4000 /* eslint-disable-line no-magic-numbers */);
  }

  initHTMLElements() {
    this.mapContentHtmlElement = this.storeLocatorHtmlElement.shadowRoot.querySelector<HTMLElement>('cwc-map-content');
    this.mapLocationHtmlElement =
      this.storeLocatorHtmlElement.shadowRoot.querySelector<HTMLElement>('cwc-map-location');
    this.sidebarHtmlElement = this.storeLocatorHtmlElement.shadowRoot.querySelector<HTMLElement>('cwc-map-sidebar');
    this.searchHtmlElement = this.storeLocatorHtmlElement.shadowRoot.querySelector<HTMLElement>('cwc-map-search');
    this.mapHtmlElement = this.storeLocatorHtmlElement.shadowRoot.querySelector<HTMLElement>('cwc-map');
  }

  createTemplate(locationObj, locationProducts?) {
    TEMPLATE.locationObjKeyaccId =
      locationObj['keyacc_id'] !== undefined ? locationObj['keyacc_id'] : ConfigData.data['keyaccount'];
    //console.log('Key: ', TEMPLATE.locationObjKeyaccId);

    if (ConfigData.data['singleLocations']) {
      return TEMPLATE.createSingleLocation(locationObj);
      //return <WebComponentStoreLocatorSingleLocation ref= { locationObj } />;
      //return WebComponentStoreLocatorSingleLocation(locationObj);
    } else {
      if (locationProducts.length > 0) {
        //TEMPLATE.productBlock = locationProducts;
        TEMPLATE.productBlock = FILTER.getFilterProductsTemplate(locationProducts);
        // console.log('productBlock:', TEMPLATE.productBlock);
      }
      return TEMPLATE.createMultipleLocations(locationObj);
    }
  }

  /**
   * Initializes geolocation coordinate.
   * This function checks whether geocoordinates have been released by the user.
   * If this is the case, the map is loaded with these coordinates. Otherwise,
   * the input field for manual input is displayed.
   * In addition, the coordinates determined here are used for route calculation and the start marker.
   */
  initGeolokationCoords() {
    if (navigator.geolocation) {
      // Try HTML5 geolocation.

      MULTIPLELOCATIONSSERVICE.currentLocationRequest = true;

      navigator.geolocation.getCurrentPosition(
        (position) => {
          // success
          const geoCoords = {
            lat: position.coords.latitude,
            lng: position.coords.longitude,
          };
          this.sendLocationRequest(geoCoords);
          this.geoCoords = geoCoords;
        },
        () => {
          // error
          this.displaySearchElement();
        },
      );
    } else {
      // Browser doesn't support Geolocation
      this.geoCoords = { lat: Number(ConfigData.data['latitude']), lng: Number(ConfigData.data['longitude']) };
    }
  }

  displaySearchElement() {
    const searchElement = SEARCHSERVICE.initSearchElement();

    if (ConfigData.data['showOnsitePrinterOnlyCheckbox']) {
      const checkboxElement = SEARCHSERVICE.createOnsitePrinterOnlyCheckbox();
      searchElement.appendChild(checkboxElement);
    }
    searchElement.className = 'load';
    this.mapHtmlElement.className = 'load';
    this.mapContentHtmlElement.appendChild(searchElement);
  }

  sendLocationRequest(coords: object) {
    this.setRequestData('', false, coords);
    MARKER.deleteMarkers();
    MULTIPLELOCATIONSSERVICE.xtciRequest();
  }

  createBackButton(buttonText: string) {
    const backButton = document.createElement('button');
    backButton.classList.add('location-back', 'shadow');
    backButton.innerHTML = '<span class="icon-arrow-left red"></span><span> ' + buttonText + '</span>';

    return backButton;
  }
}

export const STORELOCATORCOMPONENT = new StoreLocatorComponent();
